export function resolveIdKeyedGroupLabel(groupKey: string, readNames: Map<string, string>, cachedNames: Map<string, string>, unknownLabel: string) {
    return readNames.get(groupKey) || cachedNames.get(groupKey) || unknownLabel;
}
